// TODO Need to get value from Platformers team. Keep in mind that extra stuff is added to this URL so leave a safety buffer of about 100. After changing this make sure to test on real environment (not on localhost).
export const maxUrlSearchLength = 200;
